<template>
  <div class="game">
    <div class="container">
      <div class="game-container" v-if="!gameover">
        <AnimatedNumber v-show="gameStarted" :value="score" class="score"></AnimatedNumber>
        <!-- <div class="title" v-show="!gameStarted">英語發音測試遊戲</div> -->
        <div class="title" v-show="!gameStarted">英語発音練習遊戯</div>
        <div class="game-button" @click="startGame" v-show="!gameStarted">START</div>
        <Listening class="spinner" :color="interimVisible ? '#ddd' : '#f88'" v-show="gameStarted"/>
        <div
          v-for="problem in problems"
          class="problem-block"
          :style="`transform: translateX(calc(${problem.xPosition}px - 50%)) ${problem.moving ? `translateY(1100px)` : ``}`"
        >
          <transition name="bounce">
            <div
              v-if="problem.health>0 && problem.live && problem.born"
              class="inner"
              @click="speak(problem.text)"
            >
              <img class="cat" v-show="problem.health === 100" src="@/assets/cat.png">
              <img class="cat" v-show="problem.health !== 100" src="@/assets/cat_damaged.png">
              {{problem.text}}
              <div class="health" :style="`width: ${problem.health}%`"></div>
            </div>
          </transition>
        </div>
        <div class="user-speech">
          <div v-show="interimVisible" class="interim">{{interimTranscription}}</div>
          <div v-show="!interimVisible">{{finalTranscription}}</div>
        </div>
        <div class="player-health-container" v-show="gameStarted">
          <div class="health" :style="`width: ${playerHealth}%`"></div>
        </div>
      </div>
      <div class="result" v-if="gameover">
        <div class="gameover">GAMEOVER</div>
        <div class="result-score">{{score}}</div>
        <div class="download-button" @click="downloadWithZipped">Download Result Details</div>
      </div>
    </div>
  </div>
</template>

<script>
import SpeechRecognizer from "@/utils/SpeechRecognizer";
import SpeechSynthesizer from "@/utils/SpeechSynthesizer";
import pronDict from "@/utils/PronDictionary";
import AnimatedNumber from "./AnimatedNumber.vue";
const correctSE = new Audio(require("@/assets/correct.mp3"));
import { saveAs } from "file-saver";
import JSZip from "jszip";

// should be a component ?
class Problem {
  constructor(args) {
    this.text = args.text;
    this.xPosition = args.xPosition;
    this.health = 100;
    this.timeElapsed = 0;
    this.moving = false;
    this.born = false;
    this.live = true;
    setTimeout(() => {
      this.born = true;
    }, 100);
    setInterval(() => {
      this.timeElapsed++;
      if (this.timeElapsed > 25) {
        this.live = false;
      }
    }, 1000);
  }
  move() {
    this.moving = true;
  }
}

export default {
  components: {
    AnimatedNumber,
    Listening: require("@/components/Listening").default
  },
  watch: {
    problems: {
      handler: function(val, oldVal) {
        const killedCount = val.filter(problem => {
          return problem.health <= 0;
        }).length;
        const attackedCount = val.filter(problem => {
          return !problem.live && problem.health > 0;
        }).length;

        const playerHealth = 100 + killedCount * 5 - attackedCount * 10;

        if (playerHealth <= 0) {
          this.gameover = true;
          this.sr.stopRecog();
        }
      },
      deep: true
    }
  },
  computed: {
    playerHealth() {
      return 100 + this.killedCount * 5 - this.attackedCount * 10;
    },
    killedCount() {
      return this.problems.filter(problem => {
        return problem.health <= 0;
      }).length;
    },
    attackedCount() {
      return this.problems.filter(problem => {
        return !problem.live && problem.health > 0;
      }).length;
    }
  },
  data() {
    return {
      activeTraining: true,
      width: `1000px`,
      problems: [],
      sr: null,
      interimTranscription: "",
      finalTranscription: "",
      interimVisible: true,
      gameStarted: false,
      gameover: false,
      score: 0,
      playerData: []
    };
  },
  methods: {
    downloadWithZipped() {
      const today = new Date();
      const date = `${today.getFullYear()}${today.getMonth() +
        1}${today.getDate()}-${today.getHours()}${today.getMinutes()}`;
      const zip = new JSZip();
      zip.file("[Score][Model Text][Your Pronunciation]", "Hello World\n");
      this.playerData.forEach((data, index) => {
        zip.file(
          `[${data.score}][${data.possibleModelText || "Not Found"}][${
            data.playerText
          }].wav`,
          data.audio
        );
      });
      zip
        .generateAsync({ type: "blob" })
        .then(blob => saveAs(blob, `PronAid_Result_${date}`));
    },
    speak(text) {
      SpeechSynthesizer.speak({
        text: text,
        rate: 0.8,
        sr: this.sr
      });
    },
    addResult(result) {
      const self = this;
      const speechData = result.detail;
      if (speechData.isFinal) {
        this.interimVisible = false;
        this.finalTranscription = speechData.textOriginal;

        const visibleProblems = this.problems.filter(problem => problem.live);
        const promises = visibleProblems.map(problem => {
          return pronDict.getScore(problem.text, speechData.textOriginal);
        });

        let deduceScore = 0;
        let deleteWord;

        Promise.all(promises).then(compared => {
          compared.forEach(el => {
            if (el.score > deduceScore) {
              deduceScore = el.score;
              deleteWord = el.modelText;
            }
          });
          const audio = speechData.audio;
          const score = Math.round(deduceScore);
          self.playerData.push({
            possibleModelText: deleteWord,
            playerText: speechData.textOriginal,
            score,
            audio
          });
          self.problems.forEach((el, index) => {
            if (el.text === deleteWord) {
              const killed =
                this.problems[index].health - deduceScore <= 0 &&
                this.problems[index].live;

              this.problems[index].health -= deduceScore;
              this.score += score;
              if (killed) {
                correctSE.play();
              }
            }
          });
        });
      } else {
        this.interimVisible = true;
        this.interimTranscription = speechData.textOriginal;
      }
    },
    moveAll() {
      setTimeout(() => {
        this.problems.forEach(problem => {
          problem.move();
        });
      }, 100);
    },
    addProblem() {
      var randomWords = require("random-words");
      randomWords({ min: 3, max: 10 });
      this.problems.push(
        new Problem({
          text: randomWords({ min: 1, max: 2 }).join(" "),
          xPosition: 150 + Math.random() * 400
        })
      );
      this.moveAll();
    },
    startGame() {
      this.gameStarted = true;
      this.sr = new SpeechRecognizer({
        component: this
      });
      this.sr.startRecog();
      document.addEventListener("speech-result", this.addResult);
      setInterval(() => {
        this.addProblem();
      }, 3000);
    }
  },

  mounted() {}
};
</script>

<style lang="scss" scoped>
.game-container {
  overflow: hidden;
  display: block;
  margin: 0 auto;
  position: relative;
  margin-top: 50px;
  width: 850px;
  height: 1000px;
  border: 1px solid #eee;
  padding: 10px;
  background: #fff;
  background-image: linear-gradient(
      90deg,
      rgba(244, 244, 244, 0.2) 50%,
      transparent 50%
    ),
    linear-gradient(rgb(255, 255, 255) 50%, transparent 50%);
  background-size: 11px 11px;
}

.user-speech {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  padding: 500px 0;
  text-align: center;
  font-size: 5rem;
  /* border-top: 1px solid #eee; */
  font-weight: bold;
  -webkit-text-stroke: 2px rgba(0, 0, 0, 0.6);
  color: rgba(0, 0, 0, 0);
  line-height: 5rem;
  font-feature-settings: "palt";
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(10deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
.problem-block {
  transition: transform 25s linear;
  display: inline-block;
  position: absolute;
  left: 0;
  top: 0px;
  z-index: 100000;
  cursor: pointer;

  .inner {
    position: relative;
    padding: 17px 27px;
    font-size: 1.2rem;
    font-weight: bold;
    background-color: #fff;
    transition: transform 0.3s ease;
    @include block-shadow;
    .cat {
      position: absolute;
      top: -34px;
      width: 60px;
      right: 0px;
      animation: spin 3.5s ease-in-out infinite;
    }
    .health {
      position: absolute;
      transition: width 0.3s ease;
      bottom: 0;
      left: 0;
      height: 4px;
      background-color: #f88;
    }
    &:hover {
      transform: scale(1.1);
    }
  }
}
.interim {
  /* filter: blur(9px); */
  opacity: 0.1;
}
.player-health-container {
  width: 100%;
  height: 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  .health {
    transition: width 0.3s ease;
    background-color: #f88;
    width: 100%;
    height: 100%;
  }
}

.title {
  position: absolute;
  color: $main-color;
  font-size: 3rem;
  font-weight: 100;
  left: 0;
  right: 0;
  top: 8rem;
  margin: 0 auto;
  width: 70px;
  text-align: center;
  line-height: 4rem;
}

.game-button {
  cursor: pointer;
  @include dark-shadow;
  padding: 3px 50px;
  display: inline-block;
  position: absolute;
  right: 0;
  bottom: 14rem;
  left: 0;
  width: 100px;
  height: 50px;
  margin: auto;
  background-color: #f88;
  color: #fff;
  border-radius: 50px;
  font-weight: bold;
  text-align: center;
  /* -webkit-text-stroke: 1px white; */
  font-size: 2rem;
  z-index: 1000;
  transition: all 0.3s ease;
  &:hover {
    color: $main-color;
    background-color: white;
    transform: scale(1.2);
  }
}

.score {
  position: absolute;
  -webkit-text-stroke: 2px rgba(0, 0, 0, 0.6);
  color: rgba(0, 0, 0, 0);
  font-size: 6rem;
  font-weight: bold;
  bottom: 50px;
  text-align: center;
  display: block;
  width: 100%;
}

.spinner {
  position: absolute;
  transform: scale(3);
  right: 50px;
  bottom: 50px;
}
//animation

.bounce-enter-active {
  animation: bounce-in 0.6s;
}
.bounce-leave-active {
  animation: bounce-out 0.6s;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes bounce-out {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(0);
  }
}

.result {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  position: relative;
  margin-top: 50px;
  width: 850px;
  height: 1000px;
  border: 1px solid #eee;
  padding: 10px;
  font-size: 3rem;
  font-weight: bold;
  text-align: center;
  justify-content: space-evenly;
  background: #fff;
  background-image: linear-gradient(
      90deg,
      rgba(244, 244, 244, 0.2) 50%,
      transparent 50%
    ),
    linear-gradient(rgb(255, 255, 255) 50%, transparent 50%);
  background-size: 11px 11px;
  .result-score {
    -webkit-text-stroke: 5px rgba(0, 0, 0, 0.6);
    color: rgba(0, 0, 0, 0);
    font-size: 7rem;
  }

  .gameover {
    font-size: 8rem;
    -webkit-text-stroke: 5px rgba(0, 0, 0, 0.6);
    color: rgba(0, 0, 0, 0);
  }
  .download-button {
    cursor: pointer;
    @include dark-shadow;
    padding: 3px 50px;
    width: 32 0px;
    border: none;
    background-color: #f88;
    color: #fff;
    border-radius: 50px;
    font-weight: bold;
    text-align: center;
    /* -webkit-text-stroke: 1px white; */
    font-size: 1.6rem;
    z-index: 1000;
    transition: all 0.3s ease;
    &:hover {
      color: $main-color;
      background-color: white;
      transform: scale(1.1);
    }
  }
}
</style>
